import { createApi } from "@reduxjs/toolkit/query/react";
import { ProductDetailInterface } from "../interfaces/apiV2/product/ProductDetailInterface";
import { ProductDownloadsWithCountsInterface } from "../interfaces/apiV2/product/ProductDownloadsInterface";
import { apiBaseQuery } from "../utils/apiBaseQuery";

interface GetProductDetailsV2Args {
    productId: string;
    countryId: number;
}

interface GetProductDownloadsArgs {
    productId: string;
    countryId: number;
}

export const productDetailsApiSlice = createApi({
    reducerPath: "productDetailsApi",
    baseQuery: apiBaseQuery(),
    tagTypes: [],
    endpoints: (builder) => ({
        getProductDetailsV2: builder.query<
            ProductDetailInterface,
            GetProductDetailsV2Args
        >({
            query: ({ productId }) => ({
                url: `apiV2/dealer/products/${productId}`,
            }),
            transformResponse: (response: { data: ProductDetailInterface }) =>
                response.data,
        }),
        getProductDownloads: builder.query<
            ProductDownloadsWithCountsInterface,
            GetProductDownloadsArgs
        >({
            query: ({ productId }) => ({
                url: `apiV2/dealer/products/${productId}/downloads`,
            }),
            transformResponse: (response: {
                data: Pick<
                    ProductDownloadsWithCountsInterface,
                    "marketing" | "technical"
                >;
                meta: {
                    marketing_count: number;
                    technical_count: number;
                };
            }) => ({
                marketing: response.data.marketing,
                technical: response.data.technical,
                marketingCount: response.meta.marketing_count,
                technicalCount: response.meta.technical_count,
            }),
        }),
    }),
});

export const { useGetProductDetailsV2Query, useGetProductDownloadsQuery } =
    productDetailsApiSlice;
